<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a>
    <div class="content">
      <div id="score-rate-secret-items"></div>
    </div>
  </Card>
</template>
<script>
import * as echarts from 'echarts';
import api from '../../../api/home/index';
import moment from 'moment';
export default {
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    async getData() {
      let startTime = moment().month(moment().month()).startOf('month').format('YYYY-MM-DD HH:mm:ss');
      let endTime = moment().month(moment().month()).endOf('month').format('YYYY-MM-DD HH:mm:ss');
      let params = {
        startTime,
        endTime,
        orgOrDepIds: '',
        templateModelId: '',
        taskName: '',
        pageSize: 10,
        pageNumber: 1,
        averageSort: 0,
      };
      let res = await api.getParentClassReport(params);
      let dataName = res.records.map(i => i.parentClassName);
      let dataArr = res.records.map(i => i.average);
      let chartDom = document.getElementById('score-rate-secret-items');
      this.myChart = echarts.init(chartDom, null, { renderer: 'svg' });
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '6%',
          top: '20',
          containLabel: true,
        },
        xAxis: {
          interval: 0,
          data: dataName,
          axisTick: {
            //x轴刻度线
            show: false,
          },
          axisLabel: {
            //坐标轴刻度标签的相关设置。
            formatter: function (params) {
              let val = '';
              if (params.length > 5) {
                val = params.substr(0, 5) + '...';
                return val;
              } else {
                return params;
              }
            },
          },
          axisLine: {
            lineStyle: {
              color: '#7F7F7F',
            },
          },
        },
        dataZoom: [
          {
            type: 'slider',
            showDetail: false,
            startValue: 0,
            endValue: 4,
            height: 8,
            bottom: 0,
            backgroundColor: 'rgba(229, 229, 229, 0.5)',
            dataBackground: {
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                color: 'rgba(229, 229, 229, 1)',
              },
            },
            fillerColor: 'rgba(229, 229, 229, 1)',
            borderColor: 'rgba(0, 0, 0, 0)',
            showDataShadow: false,
            brushSelect: false,
            handleStyle: {
              opacity: 0,
            },
          },
        ],
        yAxis: {
          axisLine: {
            //y轴坐标轴
            show: false,
            lineStyle: {
              color: '#7F7F7F',
            },
          },
          max: 100,
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
            },
          },
        },
        series: {
          label: {
            show: true,
            position: 'top',
            color: '#FF9900',
          },
          barWidth: 10, //柱子宽度
          itemStyle: {
            color: '#FF9900',
          },
          data: dataArr,
          type: 'bar',
        },
      };

      // 绘制图表
      this.myChart.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}

.content {
  height: 100%;
  #score-rate-secret-items {
    width: 100%;
    height: 100%;
  }
}
</style>
